import { useCallback } from 'react'
import get from 'lodash/get'
import { getPortfolioItems } from '../../../selectors'
import { useSelector } from 'react-redux'

export default function usePortfolioItem (index) {
  const itemSelector = useCallback(state => get(getPortfolioItems(state), [index]), [index])
  return useSelector(itemSelector)
}
